
import { Component, Vue, Watch } from 'vue-property-decorator'
import { Action, Getter } from 'vuex-class'
import {
    getOrderNodeList,
    getOrderReturnInfoApp,
    getReturnOrderInfo,
    modifyReturnOrder,
    OrderDtlResApi,
    OrderReturnDtlApi,
    ReturnOrderDtlParamsApi,
    updateReturnOrderStatus,
    backReturnOrder,
    getOrderOrReturnNodeList,
    getOrderRemarkList,
    modifyOrderAttachFile
} from '@/api/order'
import {
    cancelReturnOrderApi,
    confirmRefund,
    OrderDtlListDto,
    PreRtnOrderInfoDto,
    ReturnOrderInfoDto
} from '@/api/shopOrder'
import ServiceLine from '@/views/financial/template/ServiceLine.vue'
import AppendixDialog from '@/views/orderManage/template/AppendixDialog.vue'
import SelectGoods from '@/views/orderManage/template/SelectGoods.vue'
import AppendixName from '@/components/AppendixName/index.vue'
import HandleFlowDialog from '@/views/orderManage/template/HandleFlowDialog.vue'
import {
    AccountInfoListApi,
    AppendixFileDto,
    getCompanyAccountInfo
} from '@/api/commonConfig'
import math from '@/core/math'
import StepTemp from '@/components/StepTemp/index.vue'
import { backHomes, backToBefore } from '@/utils/h5ToApp'
import { toNumber } from 'lodash'
import { getCompanyLine, ServiceLineListDto, upFile } from '@/api/commonConfig'
import Clipboard from 'clipboard'

@Component({
    name: 'purchaseOrderReturnDetail',
    components: {
        AppendixDialog,
        SelectGoods,
        AppendixName,
        HandleFlowDialog,
        StepTemp,
        ServiceLine
    }
})
export default class purchaseOrderReturnDetail extends Vue {
    @Getter companyId!: string
    @Action setOrderFromPage!:(val: string) => void

    showPopover = false
    isEdit = false
    returnOrderId = ''
    currRouteId = ''
    returnOrderDtl: OrderDtlResApi[] = []
    returnOrderDtlSelect: OrderDtlResApi[] = []
    params: {
        returnOrderId?: string;
        customerId?: string;
        companyId?: string;
        shopId?: string;
        currRouteId?: string;
    } = {}
    serviceLineList: ServiceLineListDto[] = []
    selectOrderDtl: ReturnOrderDtlParamsApi[] = []
    orderInfo: OrderReturnDtlApi = {
        returnOrderStatus: 1
    }
    accountInfo: AccountInfoListApi = {}
    // 进度条数据
    stepList: any[] = []
    flag = this.$route.query.flag

    // 选中商品金额合计
    amountMoney = 0
    isEditOrder = false // 是否是修改订单状态
    fromPage = '' // fromPage=='1'的时候，说明是原生跳转过来的，此时，返回按钮需要调用原生返回方法

    /*
     returnOrderStatus	退货单状态	Int	（1待退单审核 2待收货确认 3待退款审核 4待收款确认 5已完成 6已作废 7删除）
     * */
    get isCanEdit () {
        return (
            this.orderInfo.returnOrderStatus === 1 ||
            this.orderInfo.returnOrderStatus === 5
        )
    }

    @Watch('returnOrderDtlSelect', {deep: true})
    changeGoodsList (val: OrderDtlResApi[]) {
        this.selectOrderDtl = []
        if (val && val.length > 0) {
            this.amountMoney = 0
            val.forEach((item) => {
                if (item.isChecked) {
                    this.amountMoney = Number(
                        math.mathAdd(
                            this.amountMoney,
                            math.mathMultiply(item.salePrice, item.saleAmount || 0)
                        )
                    )
                    // this.orderInfo.returnMoneySum = this.amountMoney
                    this.selectOrderDtl.push({
                        orderDtlId: item.orderDtlId,
                        returnAmount: item.saleAmount
                        // returnMoney: item.salePrice
                    })
                }
            })
        }
    }

    created () {
        this.returnOrderId = this.$route.query.returnOrderId as string
        this.currRouteId = this.$route.query.currRouteId as string
        this.params.companyId = this.companyId
        this.params.returnOrderId = this.$route.query.returnOrderId as string
        this.params.currRouteId = this.$route.query.currRouteId as string

        this.fromPage = this.$route.query.fromPage? (this.$route.query.fromPage as string): '0'
        if(this.fromPage==='1') this.setOrderFromPage('1')
        this.getInfo()
        // this.getAccountInfo()

        // 暂时
        this.returnOrderDtl = this.returnOrderDtl.map((item) => {
            // 格式化数量字段，以便和代客退单公用
            item.saleAmount = item.returnAmount
            return item
        })
        this.returnOrderDtlSelect = JSON.parse(JSON.stringify(this.returnOrderDtl))
        this.returnOrderDtlSelect.map((item) => {
            item.isChecked = true
            return item
        })
    }

    activated () {
        this.getRemarkList()
        // if (this.$route.query.fromPath === "1") {
        //   this.getRemarkList();
        // }
        this.fromPage = this.$route.query.fromPage? (this.$route.query.fromPage as string): '0'
        if(this.fromPage==='1') this.setOrderFromPage('1')
    }

    handleBack () {
        if (this.fromPage === '1') {
            backToBefore()
        } else {
            this.$router.back()
        }
    }

    /**
     * @description: 监听复制
     * @param {*} e 复制内容
     * @return {*}
     */
    copyCode (key) {
        let clipboard = new Clipboard('.copy', {
            text: trigger => key
        })
        clipboard.on('success', e => {
            this.$toast('复制成功')
        })
        clipboard.on('error', e => {
            this.$toast('该浏览器不支持复制')
            e.clearSelection()
        })
    }

    /**
     * @description: 获取备注页数据
     * @param {*}
     * @return {*}
     */
    getRemarkList () {
        let obj = {
            companyId: this.companyId,
            currRouteId: this.params.currRouteId,
            orderId: this.params.returnOrderId,
            orderType: '2'
        }
        getOrderRemarkList(obj).then((res) => {
            this.$set(
                this.orderInfo,
                'returnOrderRemarkList',
                (res.data && res.data.orderRemark) || []
            )
        })
    }

    getInfo () {
        getReturnOrderInfo(this.params).then((res) => {
            this.orderInfo = res.data
            this.params.returnOrderId = this.orderInfo.returnOrderId
            this.params.companyId = this.companyId
            this.params.shopId = this.orderInfo.shopCompanyId
            this.params.currRouteId = this.orderInfo.currRouteId

            this.getServiceLine(this.orderInfo.shopCompanyId)

            this.getStepList()
            this.accountInfo.accountBank = this.orderInfo.returnManBank
            this.accountInfo.accountId = this.orderInfo.receiveManBankNo
            this.accountInfo.accountName = this.orderInfo.returnMan

            this.returnOrderDtl = res.data.orderDtlList || []
            this.returnOrderDtl = this.returnOrderDtl.map((item) => {
                // 格式化数量字段，以便和代客退单公用
                item.saleAmount = item.returnAmount
                return item
            })

            // saleAmount改成returnAmount
            this.returnOrderDtlSelect = JSON.parse(
                JSON.stringify(this.returnOrderDtl)
            )
            this.returnOrderDtlSelect.map((item) => {
                item.isChecked = true
                return item
            })
        })
    }

    /* 取消退单 */
    cancelReturnOrder () {
        // if (!this.$action('cancelReturnOrder')) {
        //     return false
        // }
        cancelReturnOrderApi(this.params).then((res) => {
            let msg = ''
            if (res.code === '000000') {
                msg = '取消退单成功'
            } else if (res.code === '000002') {
                msg = '退货单状态已变更'
            }
            this.$dialog
                .alert({
                    message: msg
                })
                .then(() => {
                    this.getInfo()
                })
        })
    }

    /* 确认收款 */
    confirmPay () {
        if (!this.$action('updateOrderStatus8')) {
            return false
        }
        const params = {
            companyId: this.companyId,
            shopId: this.params.shopId,
            retunOrderId: this.returnOrderId,
            currRouteId: this.currRouteId
        }
        confirmRefund(params)
            .then((res) => {
                let msg = ''
                if (res.code === '000000') {
                    msg = '确认收款成功'
                } else if (res.code === '000002') {
                    msg = '退货单状态已变更'
                }
                this.$dialog
                    .alert({
                        message: msg
                    })
                    .then(() => {
                        this.getInfo()
                    })
            })
            .catch(() => {})
    }

    /* 申请退货 */
    // applyReturnGoods() {
    //     this.$router.push({
    //         path: '/choosePackage',
    //         query: {
    //             orderId: this.orderInfo.returnOrderId,
    //             currRouteId: String(this.orderInfo.currRouteId)
    //         }
    //     })
    // }

    /* 获取服务热线 */
    getServiceLine (id) {
        getCompanyLine({companyId: id}).then((res) => {
            this.serviceLineList = (res.data && res.data.serviceLineList) || []
        })
    }

    /* 联系店家 */
    showServiceLine () {
        (this.$refs.serviceLine as any).show()
    }

    // 获取银行账卡信息
    getAccountInfo () {
        getCompanyAccountInfo({companyId: this.companyId}).then((res) => {
            const data = res.data.accountList || []
            if (data && data.length > 0) {
                this.accountInfo = data[0]
            } else {
                this.accountInfo = {}
            }
        })
    }

    /* 获取上传附件信息 */
    getUploadInfo (data: AppendixFileDto[]) {
        this.$set(this.orderInfo, 'orderFileList ', data)
    }

    /* 显示上传附件弹窗 */
    showUploadFunc () {
        let orderInfo = this.orderInfo;
        (this.$refs.appendix as any).show({
            fileType: '6',
            orderFile: orderInfo.orderFileList,
            // orderId: orderInfo.orderId,
            // 上传退单附件，传退单编号
            orderId: orderInfo.returnOrderId,
            currRouteId: orderInfo.currRouteId,
            type:'2' // 1订单 2退单
        })
    }

    selectGoods () {
        (this.$refs.selectGoods as any).show(
            this.returnOrderDtl,
            this.returnOrderDtlSelect
        )
    }

    getSelectGoods (data: OrderDtlResApi[]) {
        this.returnOrderDtlSelect = data
    }

    toLog () {
        this.$router.push({
            path: '/log',
            query: {
                currRouteId: this.params.currRouteId,
                orderId: this.params.returnOrderId,
                isReturn: '1'
            }
        })
    }

    deleteOrder () {
        this.showPopover = false
        this.$dialog
            .confirm({
                title: '温馨提示',
                message: '是否确认删除当前退单?'
            })
            .then(() => {
                let query = this.$route.query
                let orderIdList = [
                    {
                        returnOrderId: query.returnOrderId, // 退单id
                        currRouteId: query.currRouteId // 分区序号
                    }
                ]
                let params = {
                    companyId: this.companyId,
                    operateType: 7, // 删除
                    returnOrderIdList: orderIdList
                }
                updateReturnOrderStatus(params).then((res) => {
                    this.$toast({
                        type: 'success',
                        message: '删除成功',
                        duration: 1000,
                        onClose: () => {
                            this.$router.back()
                            this.$eventBus.$emit('orderDetail')
                        }
                    })
                })
            })
            .catch(() => {
                console.log('取消')
            })
    }

    /**
     * 格式化金额 仅可录入数字，最少为0.00，最大为99999999.99
     * @param value
     */
    formatterMoney (value) {
        value = Number(value) > 99999999.99 ? '99999999.99' : value
        return value
            .replace(/[^0-9.]/g, '')
            .replace(/^(\\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
    }

    /**
     * @description: 获取进度条数据
     * @param {*}
     * @return {*}
     */
    getStepList () {
        let params = {
            orderId: this.params.returnOrderId,
            currRouteId: this.params.currRouteId
        }
        getOrderOrReturnNodeList(params).then((res) => {
            const list = res.data.nodeIdList || []
            this.stepList = list.map((item: any) => {
                return {
                    key: item.nodeId,
                    title: item.nodeName.replace('【客户】', '') // 将'【客户】'去掉，避免title过长
                    // isValid: item.isValid
                }
            })
        })
    }

    toRemarks () {
        this.$router.push({
            path: '/remarks',
            query: {
                orderId: this.params.returnOrderId,
                currRouteId: this.params.currRouteId,
                orderType: '2' // 1:订货单 2:退货单
            }
        })
    }

    editAmount () {
        this.isEdit = true
        this.$nextTick(() => {
            (this.$refs.returnMoney as any).focus()
        })
    }

    /**
     * 确认完成
     * 是否勾选商品，如未选择，则提示“请选择退货商品”
     * 获批退款金额是否为空，如为空则提示“请输入获批退款金额”
     */
    // returnDone() {
    //     if (!this.selectOrderDtl || this.selectOrderDtl.length <= 0) {
    //         return this.$toast('请选择退货商品')
    //     }

    //     if(!this.orderInfo.returnMoneySum || Number(this.orderInfo.returnMoneySum) === 0) {
    //         return this.$toast('请输入获批退款金额')
    //     }
    // }

    /**
     * 调用原生方法切换银行账户
     */
    selectAccountInfo () {
        if (this.orderInfo.returnOrderStatus === 1 && this.isEditOrder) {
            const data = {
                customerId: this.orderInfo.customerId,
                isShowTemporary: false, // 是否展示临时地址信息 传false就是不展示，true就是展示
                title: '选择退款账户'
            }
            this.$bridge.callHandler('enterSelectAccountInfo', {data}, (res) => {
                const data = !res ? {} : JSON.parse(res)
                this.accountInfo = data
            })
        }
    }

    /* 保存详情页修改信息 */
    // saveDetail() {
    //   /* 需求变更，商品列表不可修改 */
    //   // if (!this.selectOrderDtl || this.selectOrderDtl.length <= 0) {
    //   //     return this.$toast('请选择退货商品')
    //   // }
    //
    //   if (
    //     !this.orderInfo.returnMoneySum ||
    //     Number(this.orderInfo.returnMoneySum) === 0
    //   ) {
    //     return this.$toast("请输入获批退款金额");
    //   }
    //
    //   const param = {
    //     returnOrderId: this.params.returnOrderId,
    //     companyId: this.params.companyId,
    //     createTime: this.orderInfo.createTime,
    //     customerId: this.orderInfo.customerId,
    //     returnMan: this.accountInfo.accountName,
    //     returnManBank: this.accountInfo.accountBank,
    //     receiveManBankNo: this.accountInfo.accountId,
    //     orderFileUrl: this.orderInfo.orderFileUrl,
    //     orderFileName: this.orderInfo.orderFileName,
    //     orderFileSize: this.orderInfo.orderFileSize,
    //     returnMoneySum: this.orderInfo.returnMoneySum,
    //     currRouteId: this.params.currRouteId,
    //     returnOrderDtlList: this.selectOrderDtl
    //   };
    //
    //   console.log(param);
    //   modifyReturnOrder(param).then(() => {
    //     this.$toast({
    //       type: "success",
    //       message: "保存成功",
    //       duration: 1000,
    //       onClose: () => {
    //         this.isEditOrder = false;
    //         this.reloadInfo();
    //       }
    //     });
    //   });
    // }

    /**
     * @description: 操作方法
     * @param {*操作类型：1：退单审核2：收货确认3：退款审核6：作废7：删除8：退款确认9:退回} operateType
     * @param {*操作对象} obj
     * @return {*}
     */
    handleOperation (operateType) {
        if (!this.$action(`orderStatus${operateType}`)) {
            return false
        }
        let title
        let message
        let isRequired // 备注是否必填
        switch (operateType) {
            case 1:
                title = '退单审核'
                message = '是否确认退单审核通过？'
                isRequired = false
                break
            case 2:
                title = '收货确认'
                message = '是否确认收货完成？'
                isRequired = false
                break
            case 3:
                title = '退款审核'
                message = '是否确认退款审核通过？'
                isRequired = false
                break
            case 6:
                title = '作废确认'
                message = '是否确认作废退单？'
                isRequired = true
                break
            case 4:
                title = '确认收款'
                message = '是否确认退单收款完成？'
                isRequired = false
                break
            case 9:
                title = '退回确认'
                message = '是否确认退回退单重新审核？'
                isRequired = true
                break
        }
        (this.$refs.handleFlow as any).show({
            title,
            message,
            operateType,
            isRequired
        })
    }

    /**
     * @description: 修改退货单状态方法
     * @param {*请求参数} params
     * @param {*提示} tips
     * @return {*}
     */
    updateReturnOrderStatus (params, successTips) {
        updateReturnOrderStatus(params).then((res) => {
            this.$toast({
                type: 'success',
                message: `${successTips}`,
                duration: 1000,
                onClose: () => {
                    this.reloadInfo()
                }
            })
        })
    }

    shareOrder () {
        // if (!this.$action('returnOrderShare')) {
        //     return false
        // }
        const data = {
            title: '退单详情',
            content: '分享的内容',
            url: `http://172.16.101.69:8086/orderReturnDetail?returnOrderId=${this.params.returnOrderId}&currRouteId=${this.params.currRouteId}`
        }
        this.showPopover = false
        // 定时器是为了去掉动画关闭的时间
        setTimeout(() => {
            this.$bridge.callHandler('screenshot', {data}, (res) => {
                console.log('分享成功')
            })
        }, 300)
    }

    handleFlowConfirm ({remark, operateType}) {
        // 成功提示
        let successTips
        switch (operateType) {
            case 1:
                successTips = '退单审核通过'
                break
            case 2:
                successTips = '退单收货成功'
                break
            case 3:
                successTips = '退款审核通过，请确认退款'
                break
            case 4:
                successTips = '确认收款完成'
                break
            case 6:
                successTips = '作废成功'
                break
            case 9:
                successTips = '退回成功'
                break
        }
        // 处理获取请求参数
        let query = this.$route.query
        if (operateType === 9) {
            // 退回
            let params = {
                companyId: this.companyId,
                returnOrderId: query.returnOrderId,
                currRouteId: query.currRouteId,
                Remark: remark
            }
            backReturnOrder(params).then((res) => {
                this.$toast({
                    type: 'success',
                    message: `${successTips}`,
                    onClose: () => {
                        this.reloadInfo()
                    }
                })
            })
        } else if (operateType === 4) {
            let orderIdList = [
                {
                    currRouteId: query.currRouteId,
                    returnOrderId: query.returnOrderId
                }
            ]
            let params = {
                companyId: this.companyId,
                operateType,
                orderType: 2, // 2为退货单
                returnOrderIdList: orderIdList,
                orderRemark: remark
            }
            this.updateReturnOrderStatus(params, successTips)
        }
    }

    cancelSave () {
        this.$confirmDialog.show({
            okText: '确认',
            cancelText: '取消',
            tips: '取消后修改的内容不会保存，是否确认取消修改？',
            onOk: () => {
                this.isEditOrder = false
                return this.$router.back()
            }
        })
    }

    // 刷新订单信息对象
    reloadInfo () {
        window.sessionStorage.setItem('isRefresh', '1')
        this.getInfo()
    }

    /*
     * 附件修改
     * */
    modifyOrderAttachFile (count) {
        const params = {
            companyId: this.companyId,
            orderType: '2',
            orderId: this.orderInfo.returnOrderId,
            currRouteId: this.orderInfo.currRouteId,
            orderFileUrl: count.filePath,
            orderFileName: count.fileName,
            orderFileSize: count.fileSize
        }
        modifyOrderAttachFile(params).then((res: any) => {
            if (res.code === '000000') {
                console.log('修改成功')
            } else {
                this.$toast(res.msg)
            }
        })
    }
}
